module.exports = __webpack_public_path__ + "img/default_cover.270127b9.png";